export default __webpack_public_path__ + "static/media/heavy_box.cc780530.svg";